// Diagonal section divider — paints a triangle at the top of a section
// in the *previous* section's color, so the diagonal boundary is always
// formed by two solid colors meeting (no page-background bleed-through).
//
// Usage:
//   <section style={{ background: C.cream, position: "relative" }}>
//     <TopWedge color={C.ink} dir="right" />
//     <div style={{ position: "relative", zIndex: 2 }}>...content...</div>
//   </section>
//
// `dir`:
//   "right" — previous color tapers FROM the left edge DOWN to the right edge
//             (the diagonal slopes down-right)
//   "left"  — previous color tapers FROM the right edge DOWN to the left edge
//             (the diagonal slopes down-left)
export default function TopWedge({ color, dir = "right", height = 36 }) {
  return (
    <div
      aria-hidden
      data-testid="diagonal-wedge"
      style={{
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        height,
        background: color,
        clipPath:
          dir === "right"
            ? "polygon(0 0, 100% 0, 0 100%)" // left side full, tapers to 0 on the right
            : "polygon(0 0, 100% 0, 100% 100%)", // right side full, tapers to 0 on the left
        zIndex: 1,
        pointerEvents: "none",
      }}
    />
  );
}
